import { Button } from "@/components/atoms";
import { EmptyState } from "@/components/molecules";
import { useDriversContext } from "../../../context";

export const MyDriversEmptyState = ({ hasFilters }: { hasFilters?: boolean }) => {
  const { setStep } = useDriversContext();

  const getDescription = () => {
    if (hasFilters) {
      return "There are no drivers matching your filter criteria at the moment.";
    }
    return "You haven't added anything to this section. Get started by clicking the button below.";
  };

  return (
    <EmptyState title="My Drivers" description={getDescription()}>
      {!hasFilters && (
        <div className="flex flex-row gap-4">
          <Button variant="primary" startIcon="Add" size="md" onClick={() => setStep("invite")}>
            Invite Driver
          </Button>
        </div>
      )}
    </EmptyState>
  );
};
